// Calculs de l'onglet Règlements : solde, indicateurs, filtres.
import { remainingToPay, type PayableDoc } from './invoiceList';

export type PaymentBalance = 'full' | 'part';

export const PAYMENT_BALANCE_LABELS: Record<PaymentBalance, string> = {
  full: 'Facture soldée',
  part: 'Reste dû',
};

/** Soldée si Polaris ne voit plus de reste dû (ou, sans copie, si la facture est payée). */
export function paymentBalance(doc: { remaining_amount: number | string | null; status: string }): PaymentBalance {
  if (doc.remaining_amount === null || doc.remaining_amount === undefined) {
    return doc.status === 'paid' ? 'full' : 'part';
  }
  return Number(doc.remaining_amount) <= 0 ? 'full' : 'part';
}

export interface PaymentsKpis {
  monthAmount: number;
  monthCount: number;
  dueAmount: number;
  dueCount: number;
  lateAmount: number;
  lateCount: number;
}

/** Encaissé ce mois (règlements), reste à encaisser et échu (factures émises). */
export function paymentsKpis(
  payments: { amount: number | string; paid_on: string }[],
  docs: (PayableDoc & { paid_amount: number | string | null })[],
  now: Date,
): PaymentsKpis {
  const monthKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  const c = (v: number | string) => Math.round(Number(v) * 100);
  let month = 0;
  let monthCount = 0;
  for (const p of payments) {
    if (p.paid_on.slice(0, 7) !== monthKey) continue;
    month += c(p.amount);
    monthCount += 1;
  }
  let due = 0;
  let dueCount = 0;
  let late = 0;
  let lateCount = 0;
  for (const doc of docs) {
    const rest = remainingToPay(doc, Number(doc.paid_amount ?? 0));
    if (!rest) continue;
    due += c(rest);
    dueCount += 1;
    if (doc.status === 'overdue') {
      late += c(rest);
      lateCount += 1;
    }
  }
  return {
    monthAmount: month / 100,
    monthCount,
    dueAmount: due / 100,
    dueCount,
    lateAmount: late / 100,
    lateCount,
  };
}

export interface PaymentFilters {
  q: string;
  methods: string[];
  balances: string[];
}

export function filterPayments<T extends { method: string; balance: PaymentBalance; haystack: string }>(
  rows: T[],
  filters: PaymentFilters,
): T[] {
  const q = filters.q.trim().toLowerCase();
  return rows.filter(
    (row) =>
      (filters.methods.length === 0 || filters.methods.includes(row.method)) &&
      (filters.balances.length === 0 || filters.balances.includes(row.balance)) &&
      (!q || row.haystack.includes(q)),
  );
}
